import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { activeVersionAtom } from '../atoms/assistiveTouchAtoms';

/**
 * 登录路由决策组件
 * 根据当前激活的版本决定重定向到哪个版本的登录页面
 */
export const LoginRouter: React.FC = () => {
  const activeVersion = useAtomValue(activeVersionAtom);
  
  // 默认使用v3登录页面，但如果activeVersion是v0，则使用v0登录页面
  const loginPath = activeVersion === 'v0' ? '/v0/login' : '/v3/login';
  
  return <Navigate to={loginPath} replace />;
};

export default LoginRouter;
